/*
*
*/
import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Grid, Row, Col, Button, Input } from 'react-bootstrap';
import PropTypes from 'prop-types';

import ContentWrapper from '../Layout/ContentWrapper';
import { roundTo, decimalPlaces } from '../Common/NumberUtil';
import SpinnerButton from '../Common/SpinnerButton';

class EditPosPaymentModal extends Component {
  constructor() {
    super();
    this.state = {
      ebtAmount: 0,
      cardAmount: 0,
      cardNum: '',
      cashAmount: 0,
      change: '',
      checkAmount: 0,
      checkNum: '',
      creditAmount: 0,
      finalPrice: 0,
      mobileAmount: 0,
      netDue: 0,
    };
  }

  componentDidMount() {
    const { paymentInfo } = this.props;
    this.setState({ ...paymentInfo });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.editedPosPayment !== nextProps.editedPosPayment && nextProps.editedPosPayment === true) {
      this.props.onCloseClicked();
    }
  }

  handleSaveOnClick = () => {
    const { posID, editPosPayment } = this.props;
    const {
      ebtAmount,
      cashAmount,
      cardAmount,
      checkAmount,
      cardNum,
      checkNum,
      change,
      creditAmount,
      mobileAmount,
      netDue,
    } = this.state;
    if (parseFloat(netDue) !== 0) {
      alert('Balance Net Due is not 0, please check the numbers');
      return;
    }
    if (parseFloat(cardAmount) !== 0 && (!cardNum || cardNum.length !== 4)) {
      alert('If paying by card, please enter the last 4 digits of the credit card number');
      return;
    }
    if (parseFloat(checkAmount) !== 0 && !checkNum) {
      alert('If paying by check, please enter the check number');
      return;
    }
    editPosPayment(posID, {
      EBTCardAmount: ebtAmount,
      CashAmount: cashAmount,
      Change: change,
      CreditCardAmount: cardAmount,
      CreditCardNumber: cardNum !== '' ? cardNum : null,
      CheckAmount: checkAmount,
      CheckNum: checkNum !== '' ? checkNum : null,
      StoreCreditAmount: creditAmount,
      MobileAmount: mobileAmount,
    });
  }

  handleOnFocus = (event) => {
    // Auto-select input content
    event.target.select();
  }

  /**
   * @Input: New 'Cash' amount value
   * @Updates:
   *  - change
   *  - CashPayment
   *  - netDue
   */
  handleCashAmountChange = (cashAmount) => {
    if (isNaN(cashAmount) && cashAmount !== '-' && cashAmount !== '-.') {
      return;
    }
    let paymentTotal = cashAmount;
    if (paymentTotal === '' || paymentTotal === '-' || paymentTotal === '-.') {
      paymentTotal = 0;
    }
    if (!isNaN(parseFloat(paymentTotal))) {
      let checkAmount = 0;
      let ebtAmount = 0;
      let cardAmount = 0;
      let creditAmount = 0;
      let mobileAmount = 0;

      if (!isNaN(parseFloat(this.state.checkAmount)) && isFinite(this.state.checkAmount)) {
        checkAmount = parseFloat(this.state.checkAmount);
      }
      if (!isNaN(parseFloat(this.state.ebtAmount)) && isFinite(this.state.ebtAmount)) {
        ebtAmount = parseFloat(this.state.ebtAmount);
      }
      if (!isNaN(parseFloat(this.state.cardAmount)) && isFinite(this.state.cardAmount)) {
        cardAmount = parseFloat(this.state.cardAmount);
      }
      if (!isNaN(parseFloat(this.state.creditAmount)) && isFinite(this.state.creditAmount)) {
        creditAmount = parseFloat(this.state.creditAmount);
      }
      if (!isNaN(parseFloat(this.state.mobileAmount)) && isFinite(this.state.mobileAmount)) {
        mobileAmount = parseFloat(this.state.mobileAmount);
      }
      const totalAmount = ebtAmount + cardAmount + checkAmount + creditAmount + mobileAmount + parseFloat(paymentTotal);
      if (parseFloat(this.state.finalPrice) < 0) {
        if (paymentTotal > 0) {
          this.setState({
            cashAmount: cashAmount || 0,
            netDue: roundTo(parseFloat(this.state.finalPrice) - totalAmount, 2).toFixed(2),
            change: -roundTo(parseFloat(this.state.finalPrice) - totalAmount, 2).toFixed(2),
          });
          return;
        }
        this.setState({
          cashAmount: cashAmount || 0,
          netDue: roundTo(parseFloat(this.state.finalPrice) - totalAmount, 2).toFixed(2),
          change: -paymentTotal,
        });
        return;
      }

      if (parseFloat(this.state.finalPrice) > totalAmount) {
        this.setState({
          cashAmount: cashAmount || 0,
          netDue: roundTo(parseFloat(this.state.finalPrice) - totalAmount, 2).toFixed(2),
          change: 0,
        });
      } else {
        this.setState({
          cashAmount: cashAmount || 0,
          netDue: 0,
          change: roundTo((totalAmount) - parseFloat(this.state.finalPrice), 2).toFixed(2),
        });
      }
    }
  }

  /**
   * @Input: New 'Card' amount value
   * @Updates:
   *  - CardPayment
   *  - change
   *  - netDue
   */
  handleCardAmountChange = (cardAmount) => {
    if (isNaN(cardAmount) && cardAmount !== '-' && cardAmount !== '-.') {
      return;
    }
    let cardPaymentTotal = cardAmount;
    if (cardPaymentTotal === '' || cardPaymentTotal === '-' || cardPaymentTotal === '-.') {
      cardPaymentTotal = 0;
    }
    
    if (!isNaN(parseFloat(cardPaymentTotal))) {
      let ebtPaymentTotal = 0;
      let checkPaymentTotal = 0;
      let cashPaymentTotal = 0;
      let creditPaymentTotal = 0;
      let mobilePaymentTotal = 0;
      const {
        ebtAmount,
        cashAmount,
        checkAmount,
        creditAmount,
        mobileAmount,
        finalPrice,
      } = this.state;
      
      if (!isNaN(parseFloat(checkAmount)) && isFinite(checkAmount)) {
        checkPaymentTotal = parseFloat(checkAmount);
      }
      if (!isNaN(parseFloat(cashAmount) && isFinite(cashAmount))) {
        cashPaymentTotal = parseFloat(cashAmount);
      }
      if (!isNaN(parseFloat(ebtAmount) && isFinite(ebtAmount))) {
        ebtPaymentTotal = parseFloat(ebtAmount);
      }
      if (!isNaN(parseFloat(creditAmount)) && isFinite(creditAmount)) {
        creditPaymentTotal = parseFloat(creditAmount);
      }
      if (!isNaN(parseFloat(mobileAmount) && isFinite(mobileAmount))) {
        mobilePaymentTotal = parseFloat(mobileAmount);
      }
      const totalAmount = parseFloat(cardPaymentTotal) + checkPaymentTotal + cashPaymentTotal + ebtPaymentTotal + creditPaymentTotal + mobilePaymentTotal;
      if ((parseFloat(finalPrice) > totalAmount) || parseFloat(finalPrice) < 0) {
        this.setState({
          cardAmount: cardAmount || 0,
          netDue: roundTo(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
          change: 0,
        });
      } else {
        this.setState({
          cardAmount: cardAmount || 0,
          netDue: 0,
          change: roundTo(totalAmount - parseFloat(finalPrice), 2).toFixed(2),
        });
      }
    }
  }
  
  /**
   * @Input: New 'EBT' amount value
   * @Updates:
   *  - change
   *  - EBTPayment
   *  - netDue
   */
  handleEBTAmountChange = (ebtAmount) => {
    if (isNaN(ebtAmount) && ebtAmount !== '-' && ebtAmount !== '-.') {
      return;
    }
    let ebtPaymentTotal = ebtAmount;
    if (ebtPaymentTotal === '' || ebtPaymentTotal === '-' || ebtPaymentTotal === '-.') {
      ebtPaymentTotal = 0;
    }
    
    if (!isNaN(parseFloat(ebtPaymentTotal))) {
      let cashPaymentTotal = 0;
      let cardPaymentTotal = 0;
      let checkPaymentTotal = 0;
      let mobilePaymentTotal = 0;
      let creditPaymentTotal = 0;
      
      const {
        mobileAmount,
        cashAmount,
        cardAmount,
        checkAmount,
        creditAmount,
        finalPrice,
      } = this.state;

      if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
        cashPaymentTotal = parseFloat(cashAmount);
      }
      if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
        cardPaymentTotal = parseFloat(cardAmount);
      }
      if (!isNaN(parseFloat(checkAmount)) && isFinite(checkAmount)) {
        checkPaymentTotal = parseFloat(checkAmount);
      }
      if (!isNaN(parseFloat(creditAmount) && isFinite(creditAmount))) {
        creditPaymentTotal = parseFloat(creditAmount);
      }
      if (!isNaN(parseFloat(mobileAmount) && isFinite(mobileAmount))) {
        mobilePaymentTotal = parseFloat(mobileAmount);
      }
      const totalAmount = parseFloat(ebtPaymentTotal) + cardPaymentTotal + checkPaymentTotal + cashPaymentTotal + creditPaymentTotal + mobilePaymentTotal;
      if ((parseFloat(finalPrice) > totalAmount) || parseFloat(finalPrice) < 0) {
        this.setState({
          ebtAmount: ebtAmount || 0,
          netDue: roundTo(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
          change: 0,
        });
      } else {
        this.setState({
          ebtAmount: ebtAmount || 0,
          netDue: 0,
          change: roundTo(totalAmount - parseFloat(finalPrice), 2).toFixed(2),
        });
      }
    }
  }

  /**
   * @Input: New 'Check' amount value
   * @Updates:
   *  - checkAmount
   *  - change
   *  - netDue
   */
  handleCheckAmountChange = (checkAmount) => {
    if (isNaN(checkAmount) && checkAmount !== '-' && checkAmount !== '-.') {
      return;
    }
    let checkPaymentTotal = checkAmount;
    if (checkPaymentTotal === '' || checkPaymentTotal === '-' || checkPaymentTotal === '-.') {
      checkPaymentTotal = 0;
    }
    if (!isNaN(parseFloat(checkPaymentTotal))) {
      let cashPaymentTotal = 0;
      let cardPaymentTotal = 0;
      let creditPaymentTotal = 0;
      let ebtPaymentTotal = 0;
      let mobilePaymentTotal = 0;
      const {
        ebtAmount,
        cashAmount,
        cardAmount,
        creditAmount,
        mobileAmount,
        finalPrice,
      } = this.state;

      if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
        cashPaymentTotal = parseFloat(cashAmount);
      }
      if (!isNaN(parseFloat(ebtAmount)) && isFinite(ebtAmount)) {
        ebtPaymentTotal = parseFloat(ebtAmount);
      }
      if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
        cardPaymentTotal = parseFloat(cardAmount);
      }
      if (!isNaN(parseFloat(creditAmount)) && isFinite(creditAmount)) {
        creditPaymentTotal = parseFloat(creditAmount);
      }
      if (!isNaN(parseFloat(mobileAmount) && isFinite(mobileAmount))) {
        mobilePaymentTotal = parseFloat(mobileAmount);
      }

      const totalAmount = cardPaymentTotal + parseFloat(checkPaymentTotal) + ebtPaymentTotal + cashPaymentTotal + creditPaymentTotal + mobilePaymentTotal;
      if ((parseFloat(finalPrice) > totalAmount) || parseFloat(finalPrice) < 0) {
        this.setState({
          checkAmount: checkAmount || 0,
          netDue: roundTo(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
          change: 0,
        });
      } else {
        this.setState({
          checkAmount: checkAmount || 0,
          netDue: 0,
          change: roundTo(totalAmount - parseFloat(finalPrice), 2).toFixed(2),
        });
      }
    }
  }

  /**
   * @Input: New 'Credit' amount value
   * @Updates:
   *  - change
   *  - StoreCreditPayment
   *  - netDue
   */
  handleCreditAmountChange = (creditAmount) => {
    if (isNaN(creditAmount) && creditAmount !== '-' && creditAmount !== '-.') {
      return;
    }
    let creditPaymentTotal = creditAmount;
    if (creditPaymentTotal === '' || creditPaymentTotal === '-' || creditPaymentTotal === '-.') {
      creditPaymentTotal = 0;
    }
    if (!isNaN(parseFloat(creditPaymentTotal))) {
      let cashPaymentTotal = 0;
      let cardPaymentTotal = 0;
      let checkPaymentTotal = 0;
      let ebtPaymentTotal = 0;
      let mobilePaymentTotal = 0;
      const {
        ebtAmount,
        cashAmount,
        cardAmount,
        checkAmount,
        mobileAmount,
        finalPrice,
      } = this.state;

      if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
        cashPaymentTotal = parseFloat(cashAmount);
      }
      if (!isNaN(parseFloat(ebtAmount)) && isFinite(ebtAmount)) {
        ebtPaymentTotal = parseFloat(ebtAmount);
      }
      if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
        cardPaymentTotal = parseFloat(cardAmount);
      }
      if (!isNaN(parseFloat(checkAmount)) && isFinite(checkAmount)) {
        checkPaymentTotal = parseFloat(checkAmount);
      }
      if (!isNaN(parseFloat(mobileAmount) && isFinite(mobileAmount))) {
        mobilePaymentTotal = parseFloat(mobileAmount);
      }

      const totalAmount = ebtPaymentTotal + cardPaymentTotal + checkPaymentTotal + cashPaymentTotal + parseFloat(creditPaymentTotal) + mobilePaymentTotal;
      if ((parseFloat(finalPrice) > totalAmount) || parseFloat(finalPrice) < 0) {
        this.setState({
          creditAmount: creditAmount || 0,
          netDue: roundTo(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
          change: 0,
        });
      } else {
        this.setState({
          creditAmount: creditAmount || 0,
          netDue: 0,
          change: roundTo(totalAmount - parseFloat(finalPrice), 2).toFixed(2),
        });
      }
    }
  }

  /**
 * @Input: New 'Mobile' amount value
 * @Updates:
 *  - change
 *  - MobilePayment
 *  - netDue
 */
  handleMobileAmountChange = (mobileAmount) => {
    if (isNaN(mobileAmount) && mobileAmount !== '-' && mobileAmount !== '-.') {
      return;
    }
    let mobilePaymentTotal = mobileAmount;
    if (mobilePaymentTotal === '' || mobilePaymentTotal === '-' || mobilePaymentTotal === '-.') {
      mobilePaymentTotal = 0;
    }
    if (!isNaN(parseFloat(mobilePaymentTotal))) {
      let cashPaymentTotal = 0;
      let cardPaymentTotal = 0;
      let checkPaymentTotal = 0;
      let ebtPaymentTotal = 0;
      let creditPaymentTotal = 0;
      const {
        ebtAmount,
        cashAmount,
        cardAmount,
        checkAmount,
        creditAmount,
        finalPrice,
      } = this.state;

      if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
        cashPaymentTotal = parseFloat(cashAmount);
      }
      if (!isNaN(parseFloat(ebtAmount)) && isFinite(ebtAmount)) {
        ebtPaymentTotal = parseFloat(ebtAmount);
      }
      if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
        cardPaymentTotal = parseFloat(cardAmount);
      }
      if (!isNaN(parseFloat(checkAmount)) && isFinite(checkAmount)) {
        checkPaymentTotal = parseFloat(checkAmount);
      }
      if (!isNaN(parseFloat(creditAmount) && isFinite(creditAmount))) {
        creditPaymentTotal = parseFloat(creditAmount);
      }

      const totalAmount = ebtPaymentTotal + cardPaymentTotal + checkPaymentTotal + cashPaymentTotal + creditPaymentTotal + parseFloat(mobilePaymentTotal);
      if ((parseFloat(finalPrice) > totalAmount) || parseFloat(finalPrice) < 0) {
        this.setState({
          mobileAmount: mobileAmount || 0,
          netDue: roundTo(parseFloat(finalPrice) - totalAmount, 2).toFixed(2),
          change: 0,
        });
      } else {
        this.setState({
          mobileAmount: mobileAmount || 0,
          netDue: 0,
          change: roundTo(totalAmount - parseFloat(finalPrice), 2).toFixed(2),
        });
      }
    }
  }

  // WIP: Create generic function for handling payment input change
  // /**
  //  * @Input: New 'Card' and 'Check' amount value
  //  * @Updates:
  //  *  - 'cardAmount' or 'checkAmount'
  //  *  - change
  //  *  - netDue
  //  */
  // handlePaymentTotalChange = (value, field) => {
  //   if (!value || !field) {
  //     console.error(`handlePaymentTotalChange invalid params, value: ${value}, field: ${field}`);
  //     return;
  //   }
  //   if (isNaN(value) && value !== '-' && value !== '-.') {
  //     return;
  //   }
  //   let checkPaymentTotal = value;
  //   if (checkPaymentTotal === '' || checkPaymentTotal === '-' || checkPaymentTotal === '-.') {
  //     checkPaymentTotal = 0;
  //   }
  //   if (!isNaN(parseFloat(checkPaymentTotal))) {
  //     let paymentTotal = 0;
  //     let cardPaymentTotal = 0;
  //     const { cashAmount, cardAmount, finalPrice } = this.state;
  //     if (!isNaN(parseFloat(cashAmount)) && isFinite(cashAmount)) {
  //       paymentTotal = parseFloat(cashAmount);
  //     }
  //     if (!isNaN(parseFloat(cardAmount)) && isFinite(cardAmount)) {
  //       cardPaymentTotal = parseFloat(cardAmount);
  //     }
  //
  //     if ((parseFloat(finalPrice) > cardPaymentTotal + parseFloat(checkPaymentTotal) + paymentTotal)
  //       || parseFloat(finalPrice) < 0) {
  //       this.setState({
  //         [field]: value,
  //         netDue: roundTo(parseFloat(finalPrice) - cardPaymentTotal - parseFloat(checkPaymentTotal) - paymentTotal, 2).toFixed(2),
  //         change: '0.00'
  //       });
  //     } else {
  //       this.setState({
  //         [field]: value,
  //         netDue: '0.00',
  //         change: roundTo((cardPaymentTotal + parseFloat(checkPaymentTotal) + paymentTotal) - parseFloat(finalPrice), 2).toFixed(2)
  //       });
  //     }
  //   }
  // }

  render() {
    const {
      cashAmount,
      cardAmount,
      checkAmount,
      creditAmount,
      ebtAmount,
      mobileAmount,
      netDue,
      finalPrice,
      cardNum,
      checkNum,
      change,
    } = this.state;
    return (
      <ContentWrapper>
        <Grid fluid="true" id="edit-pos-payment-modal">
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="cash" />:</span>
            </Col>
            <Col xs={3} xsOffset={3}>
              <Input
                type="text"
                addonBefore="$"
                onChange={(e) => {
                  if (decimalPlaces(e.target.value) > 2) {
                    return;
                  }
                  this.handleCashAmountChange(e.target.value);
                }}
                onFocus={this.handleOnFocus}
                value={cashAmount}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="card" />:</span>
            </Col>
            <Col xs={3}>
              <Input
                type="text"
                addonBefore="#"
                placeholder="last 4 digits"
                onChange={(e) => {
                  if (e.target.value.length > 4) {
                    return;
                  }
                  this.setState({ cardNum: e.target.value });
                }}
                onFocus={this.handleOnFocus}
                value={cardNum}
              />
            </Col>
            <Col xs={3}>
              <Input
                type="text"
                addonBefore="$"
                name="cardAmount"
                onChange={(e) => {
                  if (decimalPlaces(e.target.value) > 2) {
                    return;
                  }
                  this.handleCardAmountChange(e.target.value);
                }}
                onFocus={this.handleOnFocus}
                value={cardAmount}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="ebt" />:</span>
            </Col>
            <Col xs={3} xsOffset={3}>
              <Input
                type="text"
                addonBefore="$"
                onChange={(e) => {
                  if (decimalPlaces(e.target.value) > 2) {
                    return;
                  }
                  this.handleEBTAmountChange(e.target.value);
                }}
                onFocus={this.handleOnFocus}
                value={ebtAmount}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="check" />:</span>
            </Col>
            <Col xs={3}>
              <Input
                type="text"
                addonBefore="#"
                placeholder="check #"
                onChange={(e) => {
                  if (isNaN(e.target.value)) {
                    return;
                  }
                  this.setState({ checkNum: e.target.value });
                }}
                onFocus={this.handleOnFocus}
                value={checkNum}
              />
            </Col>
            <Col xs={3}>
              <Input
                type="text"
                addonBefore="$"
                name="checkAmount"
                onChange={(e) => {
                  if (decimalPlaces(e.target.value) > 2) {
                    return;
                  }
                  this.handleCheckAmountChange(e.target.value);
                }}
                onFocus={this.handleOnFocus}
                value={checkAmount}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="credit" />:</span>
            </Col>
            <Col xs={3} xsOffset={3}>
              <Input
                type="text"
                addonBefore="$"
                onChange={(e) => {
                  if (decimalPlaces(e.target.value) > 2) {
                    return;
                  }
                  this.handleCreditAmountChange(e.target.value);
                }}
                onFocus={this.handleOnFocus}
                value={creditAmount}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="mobile" />:</span>
            </Col>
            <Col xs={3} xsOffset={3}>
              <Input
                type="text"
                addonBefore="$"
                onChange={(e) => {
                  if (decimalPlaces(e.target.value) > 2) {
                    return;
                  }
                  this.handleMobileAmountChange(e.target.value);
                }}
                onFocus={this.handleOnFocus}
                value={mobileAmount}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="final_dollarsign" />:</span>
            </Col>
            <Col xs={3} xsOffset={3}>
              <Input
                type="text"
                addonBefore="$"
                disabled
                value={roundTo(finalPrice, 2).toFixed(2)}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="net_due" />:</span>
            </Col>
            <Col xs={3} xsOffset={3}>
              <Input
                type="text"
                addonBefore="$"
                disabled
                value={roundTo(netDue, 2).toFixed(2)}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={1}>
              <span><Translate value="change" />:</span>
            </Col>
            <Col xs={3} xsOffset={3}>
              <Input
                type="text"
                addonBefore="$"
                disabled
                value={roundTo(change, 2).toFixed(2)}
              />
            </Col>
          </Row>
          <Row className="centerStyle">
            {/* <Button
              className="mr"
              bsStyle="success"
              type="button"
              onClick={this.handleSaveOnClick}
              disabled={this.props.editingPosPayment}
            >
              <Translate value="save" />
            </Button> */}
            <SpinnerButton
              className="mr"
              bsStyle="success"
              type="button"
              icon="fa-save"
              translation={<Translate value="save" />}
              disabled={this.props.editingPosPayment}
              loading={this.props.editingPosPayment}
              onClick={this.handleSaveOnClick}
            />
            <Button
              bsStyle="danger"
              type="button"
              onClick={this.props.onCloseClicked}
            >
              <em className="fa fa-close" />
              <Translate value="cancel" />
            </Button>
          </Row>
        </Grid>
      </ContentWrapper>
    );
  }
}

EditPosPaymentModal.propTypes = {
  onCloseClicked: PropTypes.func.isRequired,
  editPosPayment: PropTypes.func.isRequired,
  editingPosPayment: PropTypes.bool.isRequired,
  editedPosPayment: PropTypes.bool.isRequired,
  posID: PropTypes.number.isRequired,
  paymentInfo: PropTypes.shape({
    cardAmount: PropTypes.number,
    cardNum: PropTypes.string,
    cashAmount: PropTypes.number,
    ebtAmount: PropTypes.number,
    change: PropTypes.number,
    checkAmount: PropTypes.number,
    checkNum: PropTypes.string,
  }).isRequired,
};

export default EditPosPaymentModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/EditPosPaymentModal.jsx